import React, { useMemo } from 'react';
import Image from '../Image/Image';
import { useSelector } from 'react-redux';
import Ribbon from '../product-list/ribbon';
import { InternalLink } from '../form-elements/Link';
import Currency from '../../../helpers/currency';
import TireInformationModal from '../Tires/TireInformationModal';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import classnames from 'classnames';
function TireCard({ tire }) {
    const markenStandort = useSelector(markenStandortSelector);
    const isNoa = markenStandort.gesellschafterNr === "035";
    const to = useMemo(() => {
        return tire.href || `/${tire.categories[0]}/${tire.id}`;
    }, [tire]);
    
    const isOfferActive = (tire.isDeliveryOfferActive && !tire.isAB) || (tire.isPickUpOfferActive && (tire.isAB || tire.additionalPickup));

    const onlinePrice = tire.selectedBezugsquelle.onlineVK;
    const pickupPrice = tire.selectedBezugsquelle.vk_preis;
    const isPickupPrice = pickupPrice > 0 && (onlinePrice <= 0 || pickupPrice <= onlinePrice);
    const shownPrice = isPickupPrice ? pickupPrice : onlinePrice;
    const aktionPrice = isPickupPrice ? tire.aktionsPreisPickup : tire.aktionsPreis;
   

    return (
        <div className="uk-card uk-card-default uk-card-small uk-flex uk-flex-column">
            <div className="uk-card-media-top uk-flex uk-flex-center">
                <Image src={tire.imagelink} alt={tire.bezeichnung} resizeHeight={235} fit="cover" />
            </div>
            <div className="uk-card-body uk-flex uk-flex-column uk-flex-1">
                <Ribbon product={tire} isOfferActive={isOfferActive} />
                <InternalLink to={to} modifier="reset">
                    <h3 className="uk-card-title uk-text-center">
                        {(tire.aktionsPreis || tire.aktionsPreisPickup) && (
                            <div className={classnames('promotionalPriceBox_overview', { 'noaPrice': isNoa })}>
                                <div className="oldPrice">
                                    <span>statt </span>
                                    <span className="originalPrice" aria-label="ursprünglicher Preis"><Currency quantity={shownPrice} /></span>
                                </div>
                                <div className="newPrice">
                                    {!isNoa && <span className="percentage" aria-label='rabattierter Artikel'>%</span>}<Currency quantity={aktionPrice} />
                                </div>
                            </div>
                        )}
                        {!(tire.aktionsPreis || tire.aktionsPreisPickup) && (
                            <>
                                {onlinePrice !== pickupPrice && <span className='ab'>ab </span>}
                                <Currency quantity={shownPrice} />
                                <span className="uk-text-light uk-text-small">/Stück </span>
                            </>
                        )}
                    </h3>
                    <div className="uk-background-muted uk-text-center uk-text-bold uk-padding-small">{tire.hersteller.toUpperCase()}</div>
                    <div className="uk-text-left uk-margin">
                        {tire.warengruppe} <br />
                        {tire.bezeichnung} <br />
                        Geschwindigkeitsindex: {tire.geschwindigkeitsindex} bis {tire.tragfaehigkeit} km/h
                    </div>
                </InternalLink>
                <div className="uk-margin-auto-top">
                    <InternalLink to={to} modifier="reset" tabIndex={-1}>
                        <TireInformationModal tire={tire} />
                    </InternalLink>
                    <InternalLink to={to} fullWidth modifier="primary" className="uk-margin" ariaLabel={`Zum Produkt: ${tire.bezeichnung}`}>
                        ZUM PRODUKT
                    </InternalLink>
                </div>
            </div>
        </div>
    );
}

export default TireCard;
